/**
 * The application root under the providers: the router, plus the one live
 * connection the whole app shares.
 */

import { RouterProvider } from 'react-router-dom';

import { useSession } from '@/lib/queries';
import { useRealtime } from '@/lib/realtime';
import { router } from '@/router';

/**
 * Holds the SSE subscription for the lifetime of the signed-in session. The
 * client is reference-counted, so components that also call `useRealtime()`
 * (the presence stack, the connection dot) share this one stream.
 *
 * The session read here is deliberately *passive* (`enabled: false`). This
 * component sits outside the router, so it renders on `/login` too — and an
 * owning read would fire a guaranteed-401 `/auth/me` in front of the sign-in
 * form. It still re-renders when the session lands in the cache, because the
 * route guard fetches it and `useLogin` writes it, so the stream opens the
 * moment there is something to stream.
 */
function RealtimeBridge() {
  const { data } = useSession({ enabled: false });
  useRealtime({ enabled: Boolean(data) });
  return null;
}

export function App() {
  return (
    <>
      <RealtimeBridge />
      <RouterProvider router={router} />
    </>
  );
}

export default App;
